import(/* webpackMode: "eager" */ "/app/apps/web/app/(public)/product/kpi/page.tsx");
